import { createContext, useContext } from 'react'

export interface ModalQueryContext {
  openedModals: string[]
  setOpenedModals: (a: string[]) => void
  pushNewModal: (a: string) => () => void
  closeModal: (a: string) => () => void
  replaceLastModal: (a: string) => () => void
}

export const ModalContext = createContext({
  openedModals: [],
  setOpenedModals: () => {},
  pushNewModal: () => () => {},
  closeModal: () => () => {},
  replaceLastModal: () => () => {},
} as ModalQueryContext)

export const useModalContext = () => useContext(ModalContext)
